import React from 'react';
import { useParams } from 'react-router-dom';

const ProgramDetail = () => {
  const { id } = useParams();

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Program Detail</h1>
      <p>Program ID: {id}</p>
    </div>
  );
};

export default ProgramDetail;